import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { useScripture } from '../../../../../hooks/useScripture';
import styles from './FooterVerse.module.css';

export type FooterVerseProps = {
  className?: string;
};

export const FooterVerse: FunctionComponent<FooterVerseProps> = ({
  className,
}) => {
  const scripture = useScripture();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.icon} />
      <div className={styles.verse}>
        <p>{scripture.text}</p>
        <cite className={styles.reference}>{scripture.reference}</cite>
      </div>
    </div>
  );
};
